import { gql } from '@apollo/client'

export const generateBlogTagsMutation = gql`
  mutation generateBlogTags($input: GenerateBlogTagsArgs!) {
    generateBlogTags(input: $input)
  }
`
